import Content from "@/docs/cs/terms-of-use.md"
import DocLayout from "@/views/docs/_layout"

export default function TermsOfUsePage() {
  return (
    <DocLayout>
      <Content />
    </DocLayout>
  )
}
